import { render, staticRenderFns } from "./CurrencyList.vue?vue&type=template&id=39fdede3"
import script from "./CurrencyList.vue?vue&type=script&lang=js"
export * from "./CurrencyList.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./CurrencyList.vue?vue&type=style&index=0&id=39fdede3&prod&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports